const defaultOptionStringifier = option => {
  const {
    label,
    value
  } = option;
  if (typeof label === 'string') {
    return label;
  }
  if (typeof value === 'string') {
    return value;
  }

  // Fallback string representation
  return String(option);
};
export { defaultOptionStringifier };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/base/useSelect/defaultOptionStringifier.js
// module id = 1191
// module chunks = 31